exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.center[data-v-0ce09d04] {\n    margin: auto;\n    width: 50%;\n    border: 3px solid green;\n    padding: 10px;\n}\n.exercise-body[data-v-0ce09d04], .exercise-item[data-v-0ce09d04] {\n  padding-left: 1ex;\n}\n.exerciseTitle[data-v-0ce09d04] {\n  margin-bottom: 1ex;\n}\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0ce09d04","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/exercises/ExerciseTitle.vue
// module id = 888
// module chunks = 1